import React from 'react';
import { Campaign } from '~/api/models/campaign';
import { Divider } from '@rio-cloud/rio-uikit';
import { FormattedMessage, FormattedTime } from 'react-intl';

interface CampaignDetailsSectionProps {
    campaign: Campaign;
    onEditClick: () => void;
}


const CampaignDetailsSection: React.FC<CampaignDetailsSectionProps> = ({
    campaign,
    onEditClick
}) => {
    return (
        <div>
            <div className='display-flex align-items-center justify-content-between'>
                <span className='title margin-right-10'><FormattedMessage id={'intl-msg:details'}/> </span>
                <button
                    className='btn btn-link margin-left-10 padding-0'
                    onClick={onEditClick}
                >
                    <span className='rioglyph rioglyph-pencil'></span>
                </button>
            </div>
            <div className='display-flex align-items-center'>
                <Divider className='width-100pct padding-top-0'/>
            </div>
            <div className='margin-top-15'>
                <div className='row margin-bottom-10'>
                    <div className='col-4'>
                        <div className='text-color-gray'><FormattedMessage id={'intl-msg:createdAt'}/></div>
                        <div>
                            {campaign?.creationDate ? (
                                <FormattedTime value={campaign?.creationDate} year='numeric'
                                               month='2-digit' day='2-digit'/>
                            ) : (
                                <span className='text-color-gray'>—</span>
                            )}
                        </div>
                    </div>
                    <div className='col-4'>
                        <div className='text-color-gray'><FormattedMessage id={'intl-msg:createdBy'}/></div>
                        <div>{campaign?.createdBy || <span className='text-color-gray'>—</span>}</div>
                    </div>

                </div>

                <div className='row margin-bottom-10'>
                    <div className='col-4'>
                        <div className='text-color-gray'><FormattedMessage id={'intl-msg:deviceType'}/></div>
                        <div>{campaign?.deviceType || <span className='text-color-gray'>—</span>}</div>
                    </div>
                    <div className='col-8'>
                        <div className='text-color-gray'><FormattedMessage id={'intl-msg:campaign:decisionBoardUrl'}/>
                        </div>
                        <div>
                            {campaign?.decisionBoard ? (
                                <a href={campaign.decisionBoard} target='_blank' rel='noopener noreferrer'>
                                    {campaign.decisionBoard}
                                </a>
                            ) : (
                                <span className='text-color-gray'>—</span>
                            )}
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12'>
                        <div className='text-color-gray'><FormattedMessage
                            id={'intl-msg:campaign:additionalInformation'}/></div>
                        <div>{campaign?.description || <span className='text-color-gray'>—</span>}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CampaignDetailsSection;
